import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useOfferReducer, OfferProvider } from '../../../hooks/useOfferReducer';
import { useAppData } from '../../../hooks/useAppData';

import CreateOffer2 from './CreateOffer2';
import CreateOffer1 from './CreateOffer1';
import CreateOffer3 from './CreateOffer3';

const CreateOfferModalContent = ({page, isAdmin, isModalOpen, setIsModalOpen, setIsLoading, deals, setDeals, currentDeal, setCurrentDeal}) => {
  const [totalStep, setTotalStep] = useState(0);

  const { refetch: refetchAppData } = useAppData();

  const {
    formData,
    step,
    setStep,
    resetForm,
    loadDealForEdit
  } = useOfferReducer();

  // Rafraîchir les données statiques (filtres, etc.) à chaque ouverture du modal
  useEffect(() => {
    if (isModalOpen) {
      refetchAppData();
    }
  }, [isModalOpen, refetchAppData]);

  // Réinitialiser l'état au montage du composant si on crée une nouvelle offre
  useEffect(() => {
    console.log("currentDeal", currentDeal);
    if (!currentDeal) {
      resetForm();
      setStep(0);
      setTotalStep(3);
    }
  }, []); // Se déclenche seulement au montage

  useEffect(() => {
    if (currentDeal) {
      console.log(currentDeal);
      loadDealForEdit(currentDeal);
      setStep(0);
      setTotalStep(2);
    } else {
      resetForm();
      setStep(0);
      setTotalStep(3);
    }
  }, [currentDeal, loadDealForEdit, resetForm, setStep]);

  // Réinitialiser le formulaire quand le modal s'ouvre pour une nouvelle offre
  useEffect(() => {
    console.log("currentDeal", currentDeal);
    if (isModalOpen && !currentDeal) {
      console.log("resetForm");
      resetForm();
      setStep(0);
      setTotalStep(3);
    }
  }, [isModalOpen, currentDeal, resetForm, setStep]);

  const handleCancel = () => {
    setIsModalOpen(false);
    setCurrentDeal(null); // S'assurer que currentDeal soit réinitialisé
  };

  const afterClose = () => {
    setStep(0);
    resetForm();
    setCurrentDeal(null);
    console.log("close");
  };

  const styles = {
    body: {
      height: "85vh",
      maxHeight: "85vh",
      overflowY: "hidden",
      padding: "0",
      borderRadius: "12px",
    },
    header: {
      borderBottom: "1px solid #f0f0f0",
      padding: "20px 24px",
      margin: 0,
    },
    content: {
      padding: "0",
      height: "100%",
      borderRadius: "12px",
    },
  };

  const renderStepHeader = (stepNumber, title, description) => (
    <div className="bg-gray-50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 px-6 py-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className='text-xl font-semibold text-gray-900 dark:text-gray-100'>
          {title}
        </h3>
        <div className="flex items-center space-x-3">
          <span className="text-sm text-gray-500 dark:text-gray-400">Étape {stepNumber}/{totalStep}</span>
          <div className="w-20 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
            <div className={`h-full bg-blue-600 rounded-full transition-all duration-300`} 
                 style={{ width: `${(stepNumber / totalStep) * 100}%` }}></div>
          </div>
        </div>
      </div>
      <p className="text-gray-600 dark:text-gray-300">
        {description}
      </p>
    </div>
  );

  const renderFormContainer = (children) => (
    <div className="flex-1 p-8 overflow-y-auto">
      <div className="max-w-lg mx-auto">
        {children}
      </div>
    </div>
  );

  return (
    <Modal
      centered
      styles={styles}
      footer={null}
      open={isModalOpen}
      onCancel={handleCancel}
      afterClose={afterClose}
      width={800}
      className="create-offer-modal"
    >
      <div className='flex flex-col w-full h-full bg-white dark:bg-gray-800'>
        {step === 0 && (
          <>
            {renderStepHeader(
              1, 
              "Présentation de l'offre", 
              "Décrivez votre promotion et ses caractéristiques"
            )}
            {renderFormContainer(
              <CreateOffer1 
                page={page} 
              />
            )}
          </>
        )}

        {step === 1 && (
          <>
            {renderStepHeader(
              2, 
              "Configuration de l'offre", 
              "Configurez les détails et conditions de votre promotion"
            )}
            {renderFormContainer(
              <CreateOffer2 
                isAdmin={isAdmin} 
                deals={deals} 
                setDeals={setDeals} 
                setIsModalOpen={setIsModalOpen} 
                setIsLoading={setIsLoading} 
                page={page} 
              />
            )}
          </>
        )}

        {step === 2 && (
          <>
            {renderStepHeader(
              3, 
              "Finalisation", 
              "Vérifiez et finalisez votre promotion"
            )}
            {renderFormContainer(
              <CreateOffer3 
                isAdmin={isAdmin} 
                deals={deals} 
                setDeals={setDeals} 
                setIsModalOpen={setIsModalOpen} 
                setIsLoading={setIsLoading} 
                page={page} 
                currentDeal={currentDeal}
              />
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

const CreateOfferModal = (props) => {
  return (
    <OfferProvider>
      <CreateOfferModalContent {...props} />
    </OfferProvider>
  );
};

export default CreateOfferModal;
